// pages/Login.js

import React, { useState } from 'react';
import styles from '../assets/css/Login.module.css';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import ParticleBackground from '../components/ParticleBackground';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { loginUsuario } from '../services/validators/authService';
import { login as saveSession, renewSession } from '../utils/session';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const fromSessionExpiry = location.state?.fromSessionExpiry || false;
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      toast.error('Completa todos los campos');
      return;
    }

    try {
      setLoading(true);
      const token = await loginUsuario({ username, password });

      if (fromSessionExpiry) {
        renewSession();
      } else {
        saveSession(token);
      }

      toast.success(fromSessionExpiry ? 'Sesión renovada con éxito' : 'Inicio de sesión exitoso');
      setTimeout(() => navigate('/dashboard'), 1000);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className={styles.loginContainer}>
      <ParticleBackground />
      <ToastContainer />

      <motion.form
        onSubmit={handleSubmit}
        className={styles.loginForm}
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h2>Iniciar sesión</h2>

        <motion.input
          type="text"
          placeholder="Usuario"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          whileFocus={{ scale: 1.02 }}
          required
        />

        <motion.input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          whileFocus={{ scale: 1.02 }}
          required
        />

        <motion.button
          type="submit"
          disabled={loading}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          {loading ? 'Ingresando...' : 'Entrar'}
        </motion.button>

        {/* <p className={styles.linkText}>
          ¿No tenés cuenta? <Link to="/registro">Solicitá acceso</Link>
        </p> */}
      </motion.form>
    </div>
  );
}

export default Login;
